import {connect} from '@modifi/redux'
import {
  selectAuthenticationUserFirstName,
  selectAuthenticationCompanyName,
  selectAuthenticationUserLastName,
} from '@modifi/plugin-authentication'
import {selectLocale} from '@modifi/plugin-i18n'
import {aFetchAnnouncementData, selectAnnouncementToBeDisplayed} from '@modifi/plugin-banners'
import {
  selectHasCreatedTrades,
  selectIsOrderCreationDisabled,
  selectIsReportsEnabled,
  selectUserActions,
} from '@modifi/plugin-trade'

import PageLayout from './PageLayout'

const mapStateToProps = state => ({
  firstName: selectAuthenticationUserFirstName(state),
  lastName: selectAuthenticationUserLastName(state),
  companyName: selectAuthenticationCompanyName(state),
  hasCreatedTrades: selectHasCreatedTrades(state),
  isOrderCreationDisabled: selectIsOrderCreationDisabled(state),
  userActions: selectUserActions(state),
  isReportsEnabled: selectIsReportsEnabled(state),
  locale: selectLocale(state),
  hasAnyAnnouncements: !!selectAnnouncementToBeDisplayed(state)?.expiry,
})
const mapDispatchToProps = {
  fetchAnnouncementData: aFetchAnnouncementData,
}

export default connect(mapStateToProps, mapDispatchToProps)(PageLayout)
